<page-header style="background-color: #005595"></page-header>

<mat-card class="m-24">
  <mat-card-title class="f-s-30" style="color: #005595">OREGON ENVIRONMENTAL LABORATORY ACCREDITATION PROGRAM</mat-card-title>
  <mat-card-title>
    <strong>Administrator: {{admin}}</strong>
  </mat-card-title>
  <mat-card-content class="f-s-16 p-16">
    <div class="flex flex-col gap-2">
      <span>7202 NE Evergreen Parkway, Suite 100 </span>
      <span>Hillsboro, Oregon 97124 </span>
      <span>Phone: 503-693-4100</span>
      <div class="flex flex-row gap-2 sm:flex-row">
        <span class="w-1/5"><strong>Administrator:</strong></span>
        <a class="w-4/5" href={{adminEmailTo}}>{{adminEmail}}</a>
      </div>
      <div class="flex flex-row gap-2 sm:flex-row">
        <span class="w-1/5"><strong>Support:</strong></span>
        <a class="w-4/5" href={{supportEmailTo}}>{{supportEmail}}</a>
      </div>
    </div>
  </mat-card-content>
</mat-card>
